import React from 'react';
import { motion } from 'framer-motion';
import { Clock3 } from 'lucide-react';
const points = ['Noches en vela buscando actividades que nunca terminan de encajar con lo que necesitas enseñar', 'Clases improvisadas porque no encontraste material listo a tiempo', 'Alumnos desconectados que no entienden para qué sirve estudiar historia', 'Silencios incómodos frente a preguntas complejas sobre procesos históricos', 'Fines de semana perdidos armando evaluaciones y secuencias desde cero'];
export function PainPoints() {
  return <section className="bg-mist px-4 py-20" data-id="element-114" data-mp="220o0wrjszvk1">
      <div className="mx-auto max-w-3xl" data-id="element-115" data-mp="1nztsi8wr9uld">
        <motion.header initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-116" data-mp="1o14rzwj64g6o">
          <h2 className="font-serif text-3xl font-bold text-navy sm:text-4xl" data-id="element-117" data-mp="3nbczwj2euusx">
            ¿Te suena conocido esto?
          </h2>
          <p className="mt-6 rounded-2xl border border-slate-100 bg-white p-6 text-left leading-relaxed text-ink shadow-sm" data-id="element-118" data-mp="1yykc99v0f1z4">
            Domingo a las 11 de la noche. Mañana tienes clase de historia. Y
            todavía estás buscando cómo explicar la diferencia entre los
            procesos independentistas o cómo armar una actividad sobre la Guerra
            Fría que realmente funcione en el aula.
            <br data-id="element-119" data-mp="1g3nk4whc1b7l" />
            <br data-id="element-120" data-mp="1b2zlbomv3q2t" />
            <strong className="text-gold-dark" data-id="element-121" data-mp="1b3hpd7frn8la">No es tu culpa.</strong> Llevas
            años peleando con libros de texto rígidos, contenido disperso en
            internet y materiales que después tienes que reescribir enteros para
            que se adapten a tu nivel y a tu programa.
          </p>
        </motion.header>
        <h3 className="mb-6 text-center text-lg font-bold text-navy" data-id="element-122" data-mp="30g30fshr7aza">
          El costo de no tener el material correcto:
        </h3>
        <ul className="space-y-3" data-id="element-123" data-mp="2vkxjz974eoil">
          {points.map((point, i) => <motion.li initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} key={point} className="flex gap-4 rounded-xl border border-slate-100 bg-white p-4 text-sm leading-relaxed text-ink shadow-sm" data-id="element-124" data-mp="1t4vkql3sqqqs" data-mpi={i}>
              <Clock3 className="mt-0.5 shrink-0 text-gold" size={18} data-id="element-125" data-mp="1jfc13d89esuv" />
              {point}
            </motion.li>)}
        </ul>
        <div className="mt-12 border-t border-slate-200 pt-8 text-center" data-id="element-126" data-mp="1o73pbh3y0mhu">
          <p className="font-serif text-2xl font-bold text-navy" data-id="element-127" data-mp="qr7t2l27u3p0">
            Basta de regalar tu tiempo libre.
          </p>
          <p className="mt-3 text-lg text-ink" data-id="element-128" data-mp="vogc0nv6ubrb">
            Resuelve tu año entero de clases de Historia en solo{' '}
            <span className="font-bold text-gold-dark" data-id="element-129" data-mp="o5gtsljgqq9j">5 MINUTOS.</span>
          </p>
        </div>
      </div>
    </section>;
}